import script from "./RemoveDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveDemo.vue?vue&type=script&setup=true&lang=js"

import "./RemoveDemo.vue?vue&type=style&index=0&id=32188c54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32188c54"]])

export default __exports__